import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FileUploader} from 'ng2-file-upload';
import {APP_CONTS} from '../../../app.constants';
import {CodigosProductoService} from '../../../services/codigos-prodicto/codigos-producto.service';
import {GeneralService} from '../../../services/general/general.service';

@Component({
  selector: 'app-cargar-codigos',
  templateUrl: './cargar-codigos.component.html',
  styleUrls: ['./cargar-codigos.component.css']
})
export class CargarCodigosComponent implements OnInit {

  loaders = {
    archivo: false,
    submit: false,
  };

  dropZoneOver = {
    archivo: false
  };

  @ViewChild('myInput')
  myInputVariable: ElementRef;

  imageFormat = APP_CONTS.FILES.EXCEL_FORMAT_STR;
  archivoSeleccionado: any;
  reemplazoResponse: any;

  step = 1;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.EXCEL_FORMAT
  });

  constructor(
    private codigosProductoService: CodigosProductoService,
    private generalService: GeneralService
  ) { }

  ngOnInit() {
  }

  fileOverBase(e: any): void {
    this.dropZoneOver.archivo = e;
  }

  cargarArchivo(event) {
    this.reemplazoResponse = undefined;
    this.step = 1;
    if (this.uploader.queue[0]) {
      const file = this.uploader.queue[0]._file;
      if (file) {
        this.archivoSeleccionado = {file: file};
        this.validarArchivo();
      } else {
        this.archivoSeleccionado = undefined;
      }
    } else {
      this.archivoSeleccionado = undefined;
      console.log('Formato malooo');
    }
    this.uploader.queue = [];
    this.myInputVariable.nativeElement.value = '';
  }

  validarArchivo() {

    this.reemplazoResponse = undefined;
    this.loaders.archivo = true;
    this.codigosProductoService.validarArchivo(this.archivoSeleccionado.file)
      .subscribe(
        (data) => {
          this.loaders.archivo = false;
          this.archivoSeleccionado.data = data.data;
          console.log(data);
        }, (error) => {
          this.loaders.archivo = false;
          this.archivoSeleccionado.data = {errors: ['No se pudo leer el archivo.']};
          console.error(error);
        }
      );
  }

  reemplazarCodigos() {
    this.loaders.submit = true;
    this.codigosProductoService.cargarArchivo(this.archivoSeleccionado.file)
      .subscribe(
        (data) => {
          this.step = 2;
          this.loaders.submit = false;

          for (const error of data.data.errors) {
            switch (error.columna) {
              case 'codigo': {
                error.columna = 'Código';
                break;
              }
              case 'descripcion': {
                error.columna = 'Descripción';
                break;
              }
              case 'precio_neto': {
                error.columna = 'Precio Neto';
                break;
              }
            }
          }

          this.reemplazoResponse = data.data;
          console.log(data);

          // Safety-net: the bulk import can change product statuses (e.g. to
          // NO_PUBLICADO), so clean up any especial elements left pointing at
          // products that are no longer PUBLICADO.
          this.generalService
            .limpiarProductosDesactualizadosEnEspeciales()
            .subscribe();
        }, (error) => {
          this.step = 2;
          this.loaders.submit = false;
          console.error(error);
        }
      );
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/cargar-codigos/cargar-codigos.component.ts